/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_IntroInputs */

const en_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We process the following categories of personal data to provide our AI-powered job application services:`)
};

const de_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verarbeiten die folgenden Kategorien personenbezogener Daten, um unsere KI-gestützten Bewerbungsdienste bereitzustellen:`)
};

const fr_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous traitons les catégories suivantes de données personnelles pour fournir nos services de candidature alimentés par l'IA :`)
};

const es_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamos las siguientes categorías de datos personales para proporcionar nuestros servicios de solicitud de empleo con IA:`)
};

const it_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattiamo le seguenti categorie di dati personali per fornire i nostri servizi di candidatura basati sull'AI:`)
};

const nl_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij verwerken de volgende categorieen persoonlijke gegevens om onze AI-gestuurde sollicitatiediensten te leveren:`)
};

const pl_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzamy następujące kategorie danych osobowych w celu świadczenia naszych usług aplikacyjnych opartych na AI:`)
};

const fi_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsittelemme seuraavia henkilötietoluokkia tarjotaksemme tekoälypohjaisia työnhakupalveluitamme:`)
};

const da_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi behandler følgende kategorier af persondata for at levere vores AI-drevne jobansøgningstjenester:`)
};

const sv_privacy_data_processing_intro = /** @type {(inputs: Privacy_Data_Processing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi behandlar följande kategorier av personuppgifter för att tillhandahålla våra AI-drivna jobbansökningstjänster:`)
};

/**
* | output |
* | --- |
* | "We process the following categories of personal data to provide our AI-powered job application services:" |
*
* @param {Privacy_Data_Processing_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_intro = /** @type {((inputs?: Privacy_Data_Processing_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_intro(inputs)
	if (locale === "fr") return fr_privacy_data_processing_intro(inputs)
	if (locale === "es") return es_privacy_data_processing_intro(inputs)
	if (locale === "it") return it_privacy_data_processing_intro(inputs)
	if (locale === "nl") return nl_privacy_data_processing_intro(inputs)
	if (locale === "pl") return pl_privacy_data_processing_intro(inputs)
	if (locale === "fi") return fi_privacy_data_processing_intro(inputs)
	if (locale === "da") return da_privacy_data_processing_intro(inputs)
	if (locale === "sv") return sv_privacy_data_processing_intro(inputs)
	return en_privacy_data_processing_intro(inputs)
});